import {
  FETCH_INVENTORYLIST_REQUEST,
  FETCH_INVENTORYLIST_SUCCESS,
  FETCH_INVENTORYLIST_FAILURE,
} from "./inventoryListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchInventoryListRequest = () => {
  return {
    type: FETCH_INVENTORYLIST_REQUEST,
  };
};

export const fetchInventoryListSuccess = (roomList) => {
  return {
    type: FETCH_INVENTORYLIST_SUCCESS,
    payload: roomList,
  };
};

export const fetchInventoryListFailure = (error) => {
  return {
    type: FETCH_INVENTORYLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchInventoryList = (queryString, sortBy, page, outofstock, stockcheck) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };

  let url = "inventory?sort_by=" + sortBy + "&page=" + page;
  if(queryString){
    url += queryString;
  }
  if(outofstock){
    url += "&outofstock="+ outofstock;
  }
  if(stockcheck){
    url += "&stockcheck="+ stockcheck;
  }

  return async (dispatch) => {
    dispatch(fetchInventoryListRequest);
    try {
      const response = await api.get(url,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const inventoryList = response.data.data;
     // console.log("Redux Inventory List Data - ", inventoryList);
      dispatch(fetchInventoryListSuccess(inventoryList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchInventoryListFailure(errorMsg));
    }
  };
};
